import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./modal.scss";

interface ModalProps {
  isOpen?: Boolean;
  closeModal?: (event: React.MouseEvent) => void;
  children?: React.ReactNode;
  title?: String;
  hideClose?: Boolean;
}

export default function Modal(props: ModalProps) {
  return (
    <AnimatePresence>
      {props.isOpen && (
        <motion.div
          className="modal-backdrop"
          style={{ position: "fixed", top: 0, left: 0, zIndex: 101 }}
          initial={{ backgroundColor: "rgba(0,0,0,0.4)" }}
          animate={{
            backgroundColor: "rgba(0,0,0,0.6)",
            transition: { duration: 0.1 },
          }}
          exit={{ opacity: 0 }}
          transition={{ damping: 100 }}
        >
          <div className="modal-container">
            <motion.div
              initial={{ scale: 0, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ type: "tween", duration: 0.65, ease: "backOut" }}
              exit={{ scale: 0, opacity: 0 }}
              className="dialog-box"
            >
              {props.title && (
                <div className="title-bar">
                  <div className="title">{props.title}</div>
                  {!props.hideClose && (
                    <div className="close-button" onClick={props.closeModal}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                      >
                        <polygon
                          fill="#FFEDEC"
                          points="295.305 40 300.061 32.991 304.756 40 309.97 40 302.896 29.878 310 20 304.695 20 300.091 26.847 295.701 20 290.488 20 297.226 29.878 290 40"
                          transform="translate(-290 -20)"
                        />
                      </svg>
                    </div>
                  )}
                </div>
              )}
              {props.children}
            </motion.div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
